import { SVGProps, Ref, forwardRef } from 'react';

export const MapPinFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 11C2 6 4.5 1 12 1s10 5 10 10c0 5.684-3.431 7.828-7.311 10.253A61 61 0 0 0 12 23a61 61 0 0 0-2.689-1.747C5.431 18.828 2 16.684 2 11m7.8 0c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 12.272 9.8 11.733 9.8 11M8 11c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
MapPinFilledSize24Glyph.displayName = 'MapPinFilledSize24Glyph';
